import React from "react";
import ReactApexChart from "react-apexcharts";
import { Col, Row } from "react-bootstrap";

const GroupedBarChart = ({ graph }) => {
  const chartData = {
    series: graph?.totalData?.map((item) => ({
      name: item.name,
      data: item.data,
    })),

    options: {
      chart: {
        type: "bar",
        height: 430,
      },
      plotOptions: {
        bar: { horizontal: true, dataLabels: { position: "top" } },
      },
      dataLabels: {
        enabled: true,
        offsetX: -6,
        style: { fontSize: "12px", colors: ["#fff"] },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: graph?.totalCategory || [],
      },
      fill: {
        opacity: 1,
      },
      colors: graph?.categoryColor?.map(item => item?.color) ?? [],
      tooltip: { shared: true, intersect: false },
      legend: {
        position: "top",
      },
    },
  };

  return (
    <div>
      <div
        className="d-flex align-items-center justify-content-between graph__title__border bg-body-secondary"
        style={{ borderBottom: "1px solid rgb(229, 229, 229)" }}
      >
        <h6 className="m-0 fontSize12 fw-bold">
          {graph?.graphName || "Grouped Bar Chart"}
        </h6>
      </div>
      <Row>
        <Col md={1} className="chart_yaxis_legend">
          <p className="fw-bold">{graph?.yAxisName}</p>
        </Col>
        <Col md={11}>
          <div id="chart" className="p-0">
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="bar"
              height={430}
            />
          </div>
          <div className="chart_xaxis_legend">
            <p className="fw-bold">{graph?.xAxisName}</p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default GroupedBarChart;
